const wordBank = [
  'I',
  'like',
  'the',
  'and',
  'see',
  'we',
  'a',
  'to',
  'come',
  'me',
  'with',
  'my',
  'you',
  'what',
  'are',
  'now',
  'is',
  'how',
  'so',
  'friend',
  'this',
  'on',
  'will',
  'be',
  'that',
  'your',
  'go',
  'for',
  'here',
  'up',
  'make',
  'play',
  'give',
  'said',
  'good',
  'was',
  'she',
  'all',
  'some',
  'he',
  'down',
  'do',
  'went',
  'little',
  'have',
  'help',
  'walk',
  'look',
  'put',
  'off',
  'our',
  'school',
  'of',
  'from',
  'saw',
  'too',
  'show',
  'boy',
  'girl',
  'could',
  'must',
  'day',
  'into',
  'then',
  'out',
  'very',
  'say',
  'find',
  'where',
  'who',
  'over',
  'away',
  'when',
  'ask',
  'but',
  'many',
  'they',
  'there',
  'came',
  'take',
  'no',
  'yes',
  'soon',
  'new',
  'ate',
  'her',
  'them',
  'one',
  'by',
  'every',
  'stop',
  'only',
  'their',
  'just',
];

const minecraft = [
  'andesite',
  'apple',
  'beacon',
  'bedrock',
  'biome',
  'block',
  'bucket',
  'button',
  'carpet',
  'cauldron',
  'cobblestone',
  'cobweb',
  'dandelion',
  'dungeon',
  'hopper',
  'ingot',
  'inventory',
  'lava',
  'minecraft',
  'mining',
  'netherrack',
  'obsidian',
  'piston',
  'sandstone',
  'sapling',
  'spawn',
  'stairs',
  'stronghold',
  'torch',
  'zombie',
  'fish',
  'rose',
  'slab',
  'flower',
];

export { wordBank, minecraft };
